var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatNewMessage = function SvgChatNewMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M3 4.001V20A1 1 0 0 0 4.001 21H20A1 1 0 0 0 21 19.999V4A1 1 0 0 0 19.999 3H4A1 1 0 0 0 3 4.001m-2 0A3 3 0 0 1 4.001 1H20A3 3 0 0 1 23 4.001V20A3 3 0 0 1 19.999 23H4A3 3 0 0 1 1 19.999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.696 12.44v-1.68h-2.688V7.8h-1.856v2.96H8.464v1.68h2.688v3.088h1.856V12.44z"
  }))));
};
export default SvgChatNewMessage;